// extracted by mini-css-extract-plugin
export var modal = "_uu-0";
export var table = "_uu-1";